import { supabase } from '@/lib/integrations/supabase'

const RECEIPT_BUCKET = 'receipts'
const RECEIPT_MAX_BYTES = 5 * 1024 * 1024
const RECEIPT_ALLOWED_TYPES = [
  'application/pdf',
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/webp',
  'image/heic',
  'image/heif',
]

export interface ReceiptUploadResult {
  path: string
  url: string
}

export async function uploadReceipt(
  unitId: string,
  entryId: string,
  file: File,
): Promise<ReceiptUploadResult> {
  if (file.size > RECEIPT_MAX_BYTES) {
    throw new Error('O arquivo excede o limite de 5 MB.')
  }
  if (!RECEIPT_ALLOWED_TYPES.includes(file.type)) {
    throw new Error('Tipo de arquivo não permitido. Use PDF ou imagem (JPEG, PNG, WEBP).')
  }

  const ext = file.name.split('.').pop() ?? 'bin'
  const path = `${unitId}/${entryId}/receipt.${ext}`

  await supabase.storage.from(RECEIPT_BUCKET).remove([path])

  const { error: uploadError } = await supabase.storage
    .from(RECEIPT_BUCKET)
    .upload(path, file, { upsert: true })
  if (uploadError) throw uploadError

  const { error: updateError } = await supabase
    .from('financial_entries')
    .update({ receipt_url: path })
    .eq('id', entryId)
  if (updateError) throw updateError

  const { data: signedData } = await supabase.storage
    .from(RECEIPT_BUCKET)
    .createSignedUrl(path, 3600)

  return { path, url: signedData?.signedUrl ?? '' }
}

export async function getReceiptUrl(path: string): Promise<string> {
  const { data, error } = await supabase.storage
    .from(RECEIPT_BUCKET)
    .createSignedUrl(path, 3600)

  if (error) throw error
  return data.signedUrl
}

export async function deleteReceipt(entryId: string, path: string): Promise<void> {
  const { error: storageError } = await supabase.storage
    .from(RECEIPT_BUCKET)
    .remove([path])
  if (storageError) throw storageError

  const { error: updateError } = await supabase
    .from('financial_entries')
    .update({ receipt_url: null })
    .eq('id', entryId)
  if (updateError) throw updateError
}
